<template>
    <div class="col-sm-12">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <h2 class="h5 h-aside is-toggable-mobile">
                    Filters
                </h2>
                <div class="flex">
                    <div class="form-group">
                        <div class="row">
                            <div class="col-sm-12">
                                <label>From</label>
                            </div>
                        </div>
                        <el-date-picker
                            v-model="fromFilter"
                            format="M/d/yyyy"
                            value-format="yyyy-MM-dd"
                            type="date">
                        </el-date-picker>
                    </div>
                    <div class="form-group" style="margin-left:20px">
                        <div class="row">
                            <div class="col-sm-12">
                                <label>To</label>
                            </div>
                        </div>
                        <el-date-picker
                            v-model="toFilter"
                            format="M/d/yyyy"
                            value-format="yyyy-MM-dd"
                            type="date">
                        </el-date-picker>
                    </div>
                    <div class="form-group" style="margin-left:20px">
                        <div class="row">
                            <div class="col-sm-12">
                                <label>Campaign</label>
                            </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <el-select v-model="campaignFilter">
                              <el-option :label="`All`" :value="``"></el-option>
                              <el-option
                                  v-for="(name, id) in allCampaigns"
                                  :key="`campaignselect-${id}`"
                                  :label="name"
                                  :value="id">
                              </el-option>
                            </el-select>
                          </div>
                        </div>
                    </div>
                    <div class="form-group" style="margin-left:20px;min-width:150px;">
                        <div class="row">
                            <div class="col-sm-12">
                                <label>Job Category</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <el-select v-model="jobCategoriesFilter">
                                  <el-option :label="`All`" :value="``"></el-option>
                                  <el-option
                                      v-for="(name, id) in allJobCategories"
                                      :key="`jobcategoryselect-${id}`"
                                      :label="name"
                                      :value="name">
                                  </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div class="form-group" style="margin-left:20px">
                        <div class="row">
                            <div class="col-sm-12">
                                <label>Job</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <el-select v-model="jobFilter" filterable>
                                    <el-option :label="`All`" :value="``"></el-option>
                                    <el-option
                                        v-for="job in allJobs"
                                        :key="`jobselect-${job.id}`"
                                        :label="`${job.id} - ${job.title}`"
                                        :value="job.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div class="form-group" style="margin-left:20px">
                        <div class="row">
                            <div class="col-sm-12">
                                <label>Data Type</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <el-select v-model="typeFilter">
                                    <el-option :label="`All`" :value="``"></el-option>
                                    <el-option :label="`Volume`" :value="`volume`"></el-option>
                                    <el-option :label="`Spend`" :value="`spend`"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div class="form-group" style="margin-left:20px;margin-top:25px;">
                        <div class="row">
                            <div class="col-sm-12">
                                <el-button type="primary" @click="loadData">Apply Filter</el-button>
                            </div>
                        </div>
                    </div>
                    <div style="flex: 1;display: flex;justify-content:flex-end;">&nbsp;</div>
                    <div class="form-group" style="margin-left:20px;margin-top:25px;">
                        <div class="row">
                            <div class="col-sm-12">
                                <el-button type="warning" @click="csvExport">Export to CSV</el-button>
                            </div>
                        </div>
                    </div>
                    <div class="form-group" style="margin-left:20px;margin-top:25px;">
                        <div class="row">
                            <div class="col-sm-12">
                                <el-button type="warning" @click="brrExport">Export as BRR</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-tabs v-model="activeTab" type="border-card">
            <el-tab-pane label="by day" name="day">
                <employer-performance-list :data="data.day" :typeFilter="typeFilter" :groupBy="'day'" />
            </el-tab-pane>
            <el-tab-pane label="by week" name="week">
                <employer-performance-list :data="data.week" :typeFilter="typeFilter" :groupBy="'week'" />
            </el-tab-pane>
            <el-tab-pane label="by month" name="month">
                <employer-performance-list :data="data.month" :typeFilter="typeFilter" :groupBy="'month'" />
            </el-tab-pane>
            <el-tab-pane label="by experience" name="experience">
                <employer-performance-by-experience :data="data.charts" :activeTab="activeTab" />
            </el-tab-pane>
            <el-tab-pane label="by hour of day" name="hour-of-day">
                <employer-performance-by-hour-of-day :data="data.charts" :activeTab="activeTab" />
            </el-tab-pane>
            <el-tab-pane label="by day of week" name="day-of-week">
                <employer-performance-by-day-of-week :data="data.charts" :activeTab="activeTab" />
            </el-tab-pane>
            <el-tab-pane label="by day of month" name="day-of-month">
                <employer-performance-by-day-of-month :data="data.charts" :activeTab="activeTab" />
            </el-tab-pane>
            <el-tab-pane label="by type" name="type">
                <employer-performance-by-type :data="data.day" :activeTab="activeTab" />
            </el-tab-pane>
            <el-tab-pane label="BRR history" name="reports">
                <employer-performance-report-list :data="data.reports" :typeFilter="typeFilter" />
            </el-tab-pane>
        </el-tabs>
        <busy-spinner :is-on="isBusy"></busy-spinner>
        <employer-notes-wrapper :employer-id="employerId" />
    </div>
</template>

<script>
import EmployerPerformanceList from './employer-performance-list';
import EmployerPerformanceByExperience from './employer-performance-by-experience';
import EmployerPerformanceByHourOfDay from './employer-performance-by-hour-of-day';
import EmployerPerformanceByDayOfWeek from './employer-performance-by-day-of-week';
import EmployerPerformanceByDayOfMonth from './employer-performance-by-day-of-month';
import EmployerPerformanceByType from './employer-performance-by-type';
import EmployerPerformanceReportList from './employer-performance-report-list';

export default {
        components: { EmployerPerformanceList, EmployerPerformanceByExperience, EmployerPerformanceByHourOfDay, EmployerPerformanceByDayOfWeek, EmployerPerformanceByDayOfMonth, EmployerPerformanceByType, EmployerPerformanceReportList },
        props: [
            'staticData',
            'employerId',
        ],
        data() {
            return {
                data: { 
                    day: null, 
                    week: null, 
                    month: null, 
                    reports: null,
                    charts: { }
                },
                fromFilter: moment().startOf('month').format('YYYY-MM-DD'),
                toFilter: moment().format('YYYY-MM-DD'),
                campaignFilter: '',
                jobCategoriesFilter: '',
                jobFilter: '',
                typeFilter: '',
                activeTab: 'day',
            };
        },
        watch: {
            activeTab() {
                window.location.replace(window.location.origin + window.location.pathname + '#' + this.activeTab);
            }
        },
        computed: {
            getDataUrl() {
                return url('admin/employer/' + this.empId + '/employer-performance-report-get-data');
            },
            allCampaigns() {
                return this.staticData ? this.staticData.campaigns : [];
            },
            allJobCategories() {
                return this.staticData ? this.staticData.jobCategories : [];
            },
            allJobs() {
                return this.staticData ? this.staticData.jobs : [];
            },
        },
        methods: {
            loadData() {
                this.empId = this.staticData.empId;
                this.makeGet(this.getDataUrl,
                    {
                        from: moment(this.fromFilter).format('YYYY-MM-DD'),
                        to: moment(this.toFilter).format('YYYY-MM-DD'),
                        emp_id: this.empId,
                        campaign_id: this.campaignFilter,
                        job_category: this.jobCategoriesFilter,
                        job_id: this.jobFilter,
                    },
                    (data) => {
                        this.data.day = data.day;
                        this.data.week = data.week;
                        this.data.month = data.month;
                        this.data.reports = data.reports;
                        this.data.charts = data.charts;
                    });
            },
            csvExport() {
                let endpoint = `admin/employer/${this.staticData.empId}/employer-performance-report-csv-export`;
                let fromFilter = 'from=' + moment(this.fromFilter).format('YYYY-MM-DD');
                let toFilter = 'to=' + moment(this.toFilter).format('YYYY-MM-DD');
                let campaignFilter = 'campaign=' + this.campaignFilter;
                let categoryFilter = 'category=' + this.jobCategoriesFilter;
                let jobFilter = 'job=' + this.jobFilter;
                let typeFilter = 'type=' + this.typeFilter;
                let dataPeriodFilter = 'data_period=' + this.activeTab;

                window.location.href = url(encodeURI(`${endpoint}?${fromFilter}&${toFilter}&${campaignFilter}&${categoryFilter}&${jobFilter}&${typeFilter}&${dataPeriodFilter}`));
            },
            brrExport() {
                let fromFilter = moment(this.fromFilter).format('YYYY-MM-DD');
                let toFilter = moment(this.toFilter).format('YYYY-MM-DD');

                window.location.href = url(`admin/employer/${this.staticData.empId}/business-review-reports/create?from=${fromFilter}&to=${toFilter}`);
            },
            focusTab(tab) {
                if (['day', 'week', 'month', 'experience', 'hour-of-day', 'day-of-week', 'day-of-month', 'type', 'reports'].includes(tab)) {
                    this.activeTab = tab;
                }
            }
        },
        mounted: function () {
            this.loadData();
            this.focusTab(window.location.hash.substring(1));
        },
    }
</script>
